import { ISearchingTag, TagName, TagType } from "./../../../shared/components/tag-searching-input/~types/models/SearchingTag";
import i18n from "src/app/shared/localization/i18n";

export const getContactSearchingTags = (): ISearchingTag[] => [
    { 
        id: 1,
        value: i18n.t("contact.phoneNumber"),
        suggestions: ["5", "7"],
        tagType: TagType.OpeningTag,
        tagName: TagName.Phone
    },
    {
        id: 2,
        value: i18n.t("contact.chatName"),
        suggestions: ["5", "8"],
        tagType: TagType.OpeningTag,
        tagName: TagName.ChatName
    },
    {
        id: 3,
        value: i18n.t("contact.externalId"),
        suggestions: ["5", "10"],
        tagType: TagType.OpeningTag,
        tagName: TagName.ContactExernalId
    },
    { 
        id: 4,
        value: i18n.t("contact.name"),
        suggestions: ["5", "9"],
        tagType: TagType.OpeningTag,
        tagName: TagName.ContactName
    },
    { 
        id: 5,
        value: "=",
        tagType: TagType.OperationTag
    },
    { 
        id: 6,
        value: "!=",
        tagType: TagType.OperationTag
    },
    { 
        id: 7,
        value: "",
        suggestions: [],
        tagType: TagType.ClosingTag,
        tagName: TagName.Phone
    },
    {
        id: 8,
        value: "",
        suggestions: [],
        tagType: TagType.ClosingTag,
        tagName: TagName.ChatName
    },
    { 
        id: 9,
        value: "",
        suggestions: [],
        tagType: TagType.ClosingTag,
        tagName: TagName.ContactName
    },
    {
        id: 10,
        value: "",
        suggestions: [],
        tagType: TagType.ClosingTag,
        tagName: TagName.ContactExernalId
    }
]